module.exports = __webpack_public_path__ + "img/ez-slot-ic_lobby_mobile_play.d64ede9b.png";